enum UploadFileType {
  ANNEX_DATA = "annex_data",
  ANNOTATION = "annotation",
  CONDITION_REPORT = "condition_report",
  TEXTURE = "texture",
  E3D_INSTANCE = "e3d_instance",
  ICON = "icon",
  TEXTURE_LAYER = "texture_layer",
}

export default UploadFileType;
